// scheduler
export const KUBERNETES = 'kubernetes';
export const LEGACY = 'legacy';

export const isK8s = (app) => app?.scheduler === KUBERNETES;

export const isLegacy = (app) => app?.scheduler === LEGACY;

